import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Col, Form, Select, Input, Button } from 'antd';

import { PlusOutlined } from '@ant-design/icons';

import { FormInstance } from 'antd/es/form/Form';
import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { ReportDocumentTypesFormValue } from '@/core/domain/reports/account/Report.types';
import { Trash2 } from 'react-feather';

interface Props {
  form: FormInstance<ReportDocumentTypesFormValue>;
}

function AccountsDocumentTypesReportForm({ form }: Props) {
  const intl = useIntl();

  return (
    <Form form={form}>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'document.modal.report.form.fiscalDocument',
            })}
            name="fiscalDoc"
          >
            <Select allowClear>
              <Select.Option value="true">
                <FormattedMessage id="document.modal.report.form.fiscalDocument.yes" />
              </Select.Option>
              <Select.Option value="false">
                <FormattedMessage id="document.modal.report.form.fiscalDocument.no" />
              </Select.Option>
            </Select>
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <FloatingFormItem
            name="active"
            label={intl.formatMessage({
              id: 'commons.entity.situation',
            })}
          >
            <Select allowClear style={{ width: '100%' }}>
              <Select.Option value="true">
                <FormattedMessage id="commons.entity.active" />
              </Select.Option>
              <Select.Option value="false">
                <FormattedMessage id="commons.entity.inactive" />
              </Select.Option>
            </Select>
          </FloatingFormItem>
        </Col>
      </Row>

      <Form.List name="description">
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field) => (
              <Form.Item
                style={{
                  margin: 1,
                  paddingTop: '1.5em',
                }}
                wrapperCol={{ span: 24, offset: 0 }}
                required={false}
                key={field.key}
              >
                <Form.Item
                  {...field}
                  validateTrigger={['onChange', 'onBlur']}
                  noStyle
                >
                  <Row gutter={[12, 12]}>
                    <Col span={fields.length > 1 ? 22 : 24}>
                      <FloatingFormItem
                        label={intl.formatMessage({
                          id: 'document.modal.report.form.description',
                        })}
                      >
                        <Input />
                      </FloatingFormItem>
                    </Col>

                    <Col span={2}>
                      {fields.length > 1 ? (
                        <Button
                          onClick={() => remove(field.name)}
                          icon={<Trash2 width={16} />}
                        />
                      ) : null}
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            ))}
            <Form.Item>
              <Button block onClick={() => add()} icon={<PlusOutlined />}>
                Adicionar descrição
              </Button>
              <Form.ErrorList errors={errors} />
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
}

export default AccountsDocumentTypesReportForm;
